import type { Rubrique, RubriqueType } from './Rubrique';
import { Tag } from './Tag';

// TODO : 'article' deviendra 'actualite'
// Routes pour le back
export type ArticleMode = 'articles' | 'decrypt_rhs';
// Routes pour le front
export const ArticleModeRouteNames: { [key in ArticleMode]: string } = {
    articles: 'actualites',
    decrypt_rhs: 'decrypt_rhs',
};
export const ArticleModeRubriqueTypes: { [key in ArticleMode]: RubriqueType } = {
    articles: 'article',
    decrypt_rhs: 'decrypt',
};

export type CommonArticleProps = {
    id: number;
    isBreve: boolean;
    title: string;
    incipit: string;
    thumbnailImage: any;
    thumbnailImagePath: string;
    slug: string;
    content: string;
    author: string;
    modifiedAt?: string;
    createdAt?: string;
};

export type ArticleProp = { article: CommonArticleProps; rubrique: Rubrique; tags: Tag[] };
export type DecryptProp = { article: CommonArticleProps & { sortOrder: number }; rubrique: Rubrique; tags: Tag[] };

export type Article = ArticleProp | DecryptProp;

export const toArticleForm = (article: Article): ArticleForm => ({
    ...article.article,
    tags: article.tags.map((t) => t.id),
    breve: article.article.isBreve,
    rubriqueId: article.rubrique.id,
    deleteThumbnailImage: false,
});

type CommonFormProp = {
    id?: number;
    rubriqueId: number;
    title: string;
    incipit: string;
    thumbnailImage: any;
    thumbnailImagePath?: string;
    deleteThumbnailImage?: boolean;
    content: string;
    breve: boolean;
    tags: number[];
};
type ArticleFormProp = CommonFormProp;
type DecryptFormProp = CommonFormProp & { sortOrder: number };

export type ArticleForm = ArticleFormProp | DecryptFormProp;

export interface RubriqueWithArticle extends Rubrique {
    articles: Article[];
}
